$(function () {
    if ($(".register-page, .resetpassword-page").length > 0) {
        //  $("#popover192346").css({ "top": $("#Password").offset().top, "left": ($("#Password").offset().left + $("#Password").width() + 50) });
        $("#ConfirmPassword").keyup(function () {
            var confirm = $(this).val();
            var pswd = $('#Password').val();
            if (confirm === pswd) {
                $('#pwsdconfirm').removeClass('fa-square').removeClass('text-danger').addClass('fa-check-square').addClass('text-success');
            } else {
                $('#pwsdconfirm').removeClass('fa-check-square').removeClass('text-success').addClass('fa-square').addClass('text-danger');
            }
        })
        .blur(function () {
            $("#confirmContainer").hide();
        })
        .focus(function () {
            $("#confirmContainer").show();
            $(".confirmContainerParent").attr('style', 'min-height:87px;'); // stop on-blur screen jump
        });

        $('#Password').keyup(function () {
            var pswd = $(this).val();
            console.log(pswd);
            if (pswd.length < 8) {
                $('#length').removeClass('fa-check-square').removeClass('text-success').addClass('fa-square').addClass('text-danger');
            } else {
                $('#length').removeClass('fa-square').removeClass('text-danger').addClass('fa-check-square').addClass('text-success');
            }

            if (pswd.match(/[a-z]/)) {
                $('#letter').removeClass('fa-square').removeClass('text-danger').addClass('fa-check-square').addClass('text-success');
            } else {
                $('#letter').removeClass('fa-check-square').removeClass('text-success').addClass('fa-square').addClass('text-danger');
            }

            if (pswd.match(/[A-Z]/)) {
                $('#letterUP').removeClass('fa-square').removeClass('text-danger').addClass('fa-check-square').addClass('text-success');
            } else {
                $('#letterUP').removeClass('fa-check-square').removeClass('text-success').addClass('fa-square').addClass('text-danger');
            }

            if (pswd.match(/\d/)) {
                $('#number').removeClass('fa-square').removeClass('text-danger').addClass('fa-check-square').addClass('text-success');
            } else {
                $('#number').removeClass('fa-check-square').removeClass('text-success').addClass('fa-square').addClass('text-danger');
            }

            if (pswd.match(/[-!$%^#@&*()_+|~=`{}\[\]:";'<>?,.\/\\]/)) {
                $('#symbol').removeClass('fa-square').removeClass('text-danger').addClass('fa-check-square').addClass('text-success');
            } else {
                $('#symbol').removeClass('fa-check-square').removeClass('text-success').addClass('fa-square').addClass('text-danger');
            }
        })
        .focus(function () {
            $("#pswdContainer").show();
        }).blur(function () {
            $("#pswdContainer").hide();
        });
    }
});

